import React from 'react';
import SmartModal from '../../smart/modal';
import { FormGroup, HelpBlock } from 'react-bootstrap'

export default class Modal extends SmartModal {
  renderForm() {
    return (
      <div>
        <SmartModal.FieldGroup
          type="text"
          label="Title"
          name="activity_category[title]"
          defaultValue={this.formValue('title')}
          error={this.formError('title')}
        />
        <SmartModal.FieldGroup
          type="file"
          label="Image"
          name="activity_category[image]"
          defaultValue={this.formValue('image')}
          error={this.formError('image')}
        />
      </div>
    );
  }
}
